<template>
  <button
    class="sys-btn text-no-wrap"
    :style="{
      background,
      color: dark ? 'white' : undefined,
      padding: `${size + 2}px ${size + 7}px ${size + 1}px`,
    }"
    v-on="inputListeners"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: "SysBtn",
  props: {
    background: {
      type: String,
      default: '#f5f4f4'
    },
    dark: Boolean,
    size: {
      type: Number,
      default: 3
    },
  },
  computed: {
    inputListeners: function () {
      return Object.assign({}, this.$listeners)
    },
  }
}
</script>

<style scoped>
.sys-btn {
  border-radius: 4px;
  display: flex;
  align-items: center;
  font-size: 16px;
  border: 1px solid #e5e5e5;
  color: #2c2c2c;
}
.sys-btn:hover {
  box-shadow: 0 0 2px #c7c6c6;
  transition: .2s;
}
</style>
